import { render, staticRenderFns } from "./com-info.vue?vue&type=template&id=3fdaacb9&scoped=true&"
var script = {}
import style0 from "./com-info.vue?vue&type=style&index=0&id=3fdaacb9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdaacb9",
  null
  
)

export default component.exports